export default {
  totalSuffix: {
    id: 'us_telco_comparators_landing_page_mobile_comparison_row_total_suffix',
    defaultMessage: 'total',
  },
  planPrefix: {
    id: 'us_telco_comparators_landing_page_mobile_comparison_row_plan_prefix',
    defaultMessage: '+ {planCost} plan',
  },
  refurbishedPhone: {
    id: 'us_telco_comparators_landing_page_mobile_comparison_row_refurbished_phone',
    defaultMessage: '{phoneCost} refurbished iPhone 15 Pro',
  },
  contractPhone: {
    id: 'us_telco_comparators_landing_page_mobile_comparison_row_contract_phone',
    defaultMessage: '{phoneCost} iPhone 15 Pro',
  },
  savingsLabel: {
    id: 'us_telco_comparators_landing_page_mobile_comparison_row_savings_label',
    defaultMessage: 'Save {amount}',
  },
}
